export default "__VITE_ASSET__VJPIZBhD__"